<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M14.5618 6.08398C14.6914 6.26622 14.7029 6.50755 14.5911 6.70117L9.21903 16H6.7825L1.41043 6.7002C1.29883 6.50657 1.31011 6.26512 1.43973 6.08301L4.20926 2.19238L5.1409 2.85449L2.58426 6.44727L8.00125 15.8242L13.4182 6.44727L10.8382 2.82324L11.7698 2.16016L14.5618 6.08398Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      d="M8.00098 5.52344C9.26317 5.52363 10.2861 6.54738 10.2861 7.80957C10.2859 8.87403 9.55748 9.76548 8.57227 10.0195V15.999H7.42969V10.0195C6.44413 9.76572 5.71505 8.87428 5.71484 7.80957C5.71484 6.54726 6.73862 5.52344 8.00098 5.52344ZM8.00098 6.66602C7.36981 6.66602 6.85742 7.17844 6.85742 7.80957C6.85767 8.44051 7.36996 8.95215 8.00098 8.95215C8.63183 8.95195 9.14331 8.44039 9.14355 7.80957C9.14355 7.17856 8.63198 6.66621 8.00098 6.66602Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M2.85742 2.66662V0H4.00031V2.0952H12.0005V0H13.1434V2.66662C13.1434 2.98222 12.8875 3.23805 12.5719 3.23805H3.42886C3.11327 3.23805 2.85742 2.98222 2.85742 2.66662Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>

<style scoped lang="scss">
svg {
  flex-shrink: 0;
  display: block;
}
</style>
